export enum ClaimStatusTypes {
    PASS = "Pass",
    FAIL = "Fail",
    UNVERIFIED = "Unverified",
    PARTIAL = "Partial",
    CLOSE = "Close",
    EXPIRED = "Expired"
}